import { computed, ref } from '@nuxtjs/composition-api';
import useTlmCart from '~/composable/useTlmCart';
import useErrorHandler from '~/composable/useErrorHandler';
import { WARNING_CODE } from '@/constants/ErrorCodes'
import useCartQueries from '~/composable/useCartQueries';

export default function useSubscriptions (appContext) {
  const validationResult = ref(null);
  const preValidationResult = ref(null);
  const hubbleClient = appContext.$hubble;
  const { catchApiFailureWithNoAction, stopFlow } = useErrorHandler()
  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  const { subscriptionList, installments, getCartID, mixPoList, cart } = useTlmCart(appContext)
  const { cartOnlyContainsSubscription } = useCartQueries(appContext, cart)

  const subscriptionSignUpData = {
    isSimOnly: cartOnlyContainsSubscription.value,
    bundleId: subscriptionList?.value?.sku,
    companyCustomer: true,
    shopReservationDTO: cartOnlyContainsSubscription.value
      ? null
      : {
          installments: installments?.value
        },
    mixServices: mixPoList.value
  }
  const validateSubscriptions = async (subscriptionSignUpDataNew) => {
    const response = await hubbleClient.subscriptions.validateNewSubscription(subscriptionSignUpDataNew, getCartID.value).catch(err => stopFlow(err))
    validationResult.value = response?.data
    return validationResult.value
  };
  const preValidateSubscriptions = async () => {
    const response = await hubbleClient.subscriptions.preValidateNewSubscription(subscriptionSignUpData).catch(err => catchApiFailureWithNoAction(err))
    preValidationResult.value = response?.data
    return preValidationResult.value
  };
  const genProperAccessToken = (accessToken, accessTokenType, userName = '', password = '') => {
    if (accessTokenType === 'UN_PW') {
      return {
        userName,
        password,
        accessTokenType
      }
    } else {
      return {
        accessToken,
        accessTokenType
      }
    }
  }
  const getPayload = ({ accessToken, accessTokenType, phoneNumber, bundleID, cartId, mixServices, userName = '', password = '' }) => ({
    accessToken: genProperAccessToken(accessToken, accessTokenType, userName, password),
    bundleId: bundleID,
    numberInfo: {
      mobileNumber: phoneNumber
    },
    cartId,
    mixServices
  })


  const preValidateChangeSubscription = async ({ accessToken, accessTokenType, phoneNumber, bundleID, cartID, mixServices, userName, password }) => {
    if (accessTokenType !== 'MIT_ID' && accessTokenType !== 'JWT' && accessTokenType !== 'UN_PW') {
      throw new Error('Only AccessTokenTypes of JWT and MIT_ID are allowed')
    }
    const response = await hubbleClient.subscriptions.preValidateChangeSubscription(getPayload({ accessToken, accessTokenType, phoneNumber, bundleID, cartId: cartID, mixServices, userName, password })).catch(err => catchApiFailureWithNoAction(err))
    preValidationResult.value = response?.data
    return preValidationResult.value
  };
  const validateChangeSubscription = async ({ accessToken, accessTokenType, phoneNumber, bundleID, cartID, mixServices, userName, password }) => {
    if (accessTokenType !== 'MIT_ID' && accessTokenType !== 'JWT' && accessTokenType !== 'UN_PW') {
      throw new Error('Only AccessTokenTypes of JWT and MIT_ID are allowed')
    }
    const response = await hubbleClient.subscriptions.validateChangeSubscription(getPayload({ accessToken, accessTokenType, phoneNumber, bundleID, cartId: cartID, mixServices, userName, password })).catch(err => catchApiFailureWithNoAction(err))
    preValidationResult.value = response?.data
    return preValidationResult.value
  };
  const isSubscriptionUpgrade = computed(() => {
    const isDowngrade = preValidationResult.value?.hasWarnings &&
      preValidationResult.value.warnings.find(warning => WARNING_CODE.CHANGE_END_OF_MONTH.includes(warning.notificationCode)) !== undefined
    // BE doesnt send the Upgrade message, so assumption at FE is that if its not a downgrade its an upgrade
    // const isUpgrade = preValidationResult.value.hasWarnings &&
    //   preValidationResult.value.warnings.find(warning => WARNING_CODE.CHANGE_END_OF_DAY === warning.notificationCode) !== undefined
    return !isDowngrade
  })
  return {
    isSubscriptionUpgrade,
    preValidationResult,
    validationResult,
    validateSubscriptions,
    preValidateSubscriptions,
    validateChangeSubscription,
    preValidateChangeSubscription
  }
}
